import React from 'react'

import { TIconProps } from '.'

const Broom: React.FC<TIconProps> = ({ color, size }) => {
  return (
    <svg
      width="18px"
      height="20px"
      viewBox="0 0 18 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-testid="icon-broom"
      style={{
        width: 'auto',
        height: size,
      }}
    >
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Limpar-Blue" transform="translate(-7.000000, -6.000000)">
          <g id="icone-limpar" transform="translate(4.000000, 4.000000)">
            <g id="BotaoLimpar">
              <rect id="Rectangle" x="0" y="0" width="24" height="24" />
            </g>
            <g id="Group-3" transform="translate(3.000000, 2.000000)" fill={color}>
              <path
                d="M5.3197732,10.536 L16.9784898,10.536 L16.9784898,9.947 C16.9595896,9.001 16.296283,8.244 15.4448744,8.223 C13.2875529,8.202 8.99180992,8.202 6.85248852,8.223 C6.11448114,8.223 5.50877509,8.812 5.37647376,9.611 C5.3197732,9.905 5.33867339,10.2 5.3197732,10.536 M12.2345423,18.78 C12.3110431,18.801 12.3299433,18.801 12.3677437,18.801 C13.3883539,18.519 16.9595896,16.992 16.9784898,14.721 L16.9784898,12.303 L16.9784898,11.756 L5.3197732,11.756 L5.3197732,14.637 C5.30087301,16.193 4.7896679,17.497 3.78705787,18.549 C3.72945729,18.612 3.65385654,18.654 3.57825578,18.696 C3.59715597,18.738 4.68616686,18.759 4.70506705,18.801 C4.95166952,18.78 5.19737197,18.78 5.42507425,18.717 C7.20349203,18.338 8.39600396,16.824 8.49140491,14.742 C8.5103051,14.343 8.71820718,14.09 9.02061021,14.09 C9.34281343,14.09 9.55071551,14.364 9.53181532,14.784 C9.47511475,16.298 8.96390964,17.56 7.96129961,18.57 C7.90459905,18.633 7.84789848,18.696 7.75249752,18.78 C8.22590226,18.78 7.57249572,18.801 8.00720007,18.78 C11.3426334,18.801 12.2156422,17.968 12.9167492,14.784 C12.9356494,14.364 13.1435514,14.111 13.4648546,14.111 C13.7870579,14.111 13.9760598,14.385 13.9760598,14.805 C13.9382594,16.298 13.4081541,17.56 12.4244442,18.57 C12.3866439,18.633 12.3299433,18.696 12.2345423,18.78 M10.4597246,7.024 L10.4597246,6.666 L10.4597246,0.841 L10.4597246,0.568 C10.497525,0.231 10.7054271,0 10.9898299,0 C11.2544325,0 11.4812348,0.231 11.501035,0.568 C11.5199352,0.673 11.501035,0.778 11.501035,0.904 L11.501035,6.708 L11.501035,7.045 C11.595536,7.045 10.7900279,7.066 10.8656287,7.066 L15.2558726,7.066 C16.8830888,7.087 18,8.328 18,10.115 L18,14.658 C17.9810998,17.686 13.7618576,20 11.0168302,20 L0.739627396,20 L0.587525875,20 C0.247322473,20 0.0196201962,19.768 0.0007200072,19.432 C-0.0181801818,19.095 0.209522095,18.843 0.549725497,18.843 C1.36423364,18.822 2.10224102,18.57 2.74574746,18.023 C3.72945729,17.182 4.22176222,16.046 4.22176222,14.679 L4.22176222,10.115 C4.22176222,8.643 5.03627036,7.508 6.30438304,7.192 C6.5500855,7.129 6.81468815,7.108 7.06129061,7.108 C7.91269913,7.024 9.62631626,7.024 10.4597246,7.024"
                id="Fill-1"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Broom
